import React, { useState } from 'react';
import { ChevronDown, ChevronRight, Package, DollarSign, CreditCard, Bell, Info, Home, MapPin, X, BarChart3 } from 'lucide-react';

const Sidebar = ({ userRole, onSectionChange, currentSection, isOpen, onClose }) => {
  const [expandedSections, setExpandedSections] = useState({
    reempaques: true,
    facturacion: false,
    pagos: false,
    alertas: false,
    info: false
  });

  const toggleSection = (section) => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  const handleSectionClick = (section) => {
    onSectionChange(section);
    // Close drawer on mobile after selection
    if (onClose) onClose();
  };

  const menuItems = userRole === 'master' ? [
    {
      id: 'home',
      label: 'Inicio',
      icon: Home,
      section: 'home'
    },
    {
      id: 'casilleros',
      label: 'Casilleros',
      icon: MapPin,
      subsections: [
        { id: 'crear-casillero', label: 'Crear Casillero', section: 'create-locker' },
        { id: 'listar-casilleros', label: 'Listar Casillero', section: 'list-lockers' },
        { id: 'lista-alertas-paquetes', label: 'Lista de Alertas de Paquete', section: 'locker-alerts' },
        { id: 'solicitudes-reempaque', label: 'Solicitudes de Reempaque', section: 'locker-repacks' }
      ]
    },
    {
      id: 'alertas',
      label: 'Alerta de Paquetes',
      icon: Bell,
      section: 'alerts'
    },
    {
      id: 'paquetes',
      label: 'Paquetes',
      icon: Package,
      subsections: [
        { id: 'crear-paquete', label: 'Crear Paquete', section: 'create-package' },
        { id: 'listar-paquetes', label: 'Listar Paquetes', section: 'packages' },
        { id: 'gestionar-paquetes', label: 'Gestionar Paquetes', section: 'manage-packages' },
        { id: 'rastrear-paquete', label: 'Rastrear Paquete', section: 'track-package' }
      ]
    },
    {
      id: 'warehouse',
      label: 'Warehouse',
      icon: Package,
      subsections: [
        { id: 'list-warehouse', label: 'Listar Warehouse', section: 'warehouse' },
        { id: 'create-manual-wr', label: 'Crear WR Manual', section: 'create-manual-wr' }
      ]
    },
    {
      id: 'facturacion',
      label: 'Facturas',
      icon: DollarSign,
      subsections: [
        { id: 'list-invoices', label: 'Listar Facturas', section: 'invoices' },
        { id: 'create-manual-invoice', label: 'Crear Factura Manual', section: 'create-manual-invoice' },
        { id: 'account-statement', label: 'Estado de Cuenta', section: 'account-statement' }
      ]
    },
    {
      id: 'pagos',
      label: 'Pagos',
      icon: CreditCard,
      section: 'payments'
    },
    {
      id: 'rates-services',
      label: 'Tarifas y Servicios',
      icon: DollarSign,
      section: 'rates-services'
    },
    {
      id: 'clientes',
      label: 'Clientes',
      icon: Info,
      subsections: [
        { id: 'list-clients', label: 'Listar Clientes', section: 'clients' },
        { id: 'create-locker', label: 'Crear Casillero', section: 'create-locker' },
        { id: 'import-clients', label: 'Importar Clientes', section: 'import-clients' }
      ]
    },
    {
      id: 'analytics',
      label: 'Reportes',
      icon: BarChart3,
      subsections: [
        { id: 'reportes', label: 'Analiticas', section: 'analytics' },
        { id: 'email-logs', label: 'Historial de Emails', section: 'email-logs' }
      ]
    }
  ] : [
    {
      id: 'principal',
      label: 'Principal',
      icon: Home,
      section: 'dashboard'
    },
    {
      id: 'paquetes',
      label: 'Paquetes',
      icon: Package,
      subsections: [
        { id: 'mis-paquetes', label: 'Paquetes', section: 'packages' },
        { id: 'warehouses', label: 'Warehouses', section: 'warehouses-list' },
        { id: 'rastrear-paquete', label: 'Rastrear Paquete', section: 'track-package' }
      ]
    },
    {
      id: 'reempaques',
      label: 'Reempaques',
      icon: Package,
      subsections: [
        { id: 'solicitudes-reempaque', label: 'Solicitar Reempaque', section: 'repack-request' },
        { id: 'mis-reempaques', label: 'Mis Reempaques', section: 'my-repacks' }
      ]
    },
    {
      id: 'facturacion',
      label: 'Facturación',
      icon: DollarSign,
      subsections: [
        { id: 'mis-facturas', label: 'Mis Facturas', section: 'invoices' },
        { id: 'mis-wr', label: 'Mis Warehouse Receipts', section: 'warehouse-receipts' }
      ]
    },
    {
      id: 'pagos',
      label: 'Pagos',
      icon: CreditCard,
      subsections: [
        { id: 'notificar-pago', label: 'Notificar Pago', section: 'notify-payment' },
        { id: 'mis-pagos', label: 'Mis Pagos', section: 'my-payments' },
        { id: 'cuentas', label: 'Cuentas Bancarias', section: 'accounts' }
      ]
    },
    {
      id: 'alertas',
      label: 'Alerta de Paquetes',
      icon: Bell,
      subsections: [
        { id: 'crear-alerta', label: 'Notificar Paquete', section: 'create-alert' },
        { id: 'mis-alertas', label: 'Mis Alertas', section: 'alerts' }
      ]
    },
    {
      id: 'info',
      label: 'Mi Cuenta',
      icon: Info,
      subsections: [
        { id: 'mis-datos', label: 'Mis Datos', section: 'profile' },
        { id: 'actualizar-datos', label: 'Actualizar Datos', section: 'update-profile' }
      ]
    }
  ];

  return (
    <>
      {/* Overlay for mobile */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden"
          onClick={onClose}
        />
      )}
      
      {/* Sidebar */}
      <div 
        className={`
          fixed md:static inset-y-0 left-0 z-50
          w-64 bg-gray-900 text-white h-full overflow-y-auto
          transform transition-transform duration-300 ease-in-out
          ${isOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'}
        `}
        data-testid="sidebar"
      >
        <div className="p-4">
          {/* Header with close button for mobile */}
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-xl font-bold">
              {userRole === 'master' ? 'Panel Master' : 'Mi Casillero'}
            </h2>
            {/* Close button only on mobile */}
            <button 
              onClick={onClose}
              className="md:hidden p-2 hover:bg-gray-800 rounded-lg"
            >
              <X size={20} />
            </button>
          </div>
          
          <nav className="space-y-2">
            {menuItems.map((item) => (
              <div key={item.id}>
                {item.subsections ? (
                  <div>
                    <button
                      onClick={() => toggleSection(item.id)}
                      className="w-full flex items-center justify-between p-3 hover:bg-gray-800 rounded-lg transition-colors"
                      data-testid={`menu-${item.id}`}
                    >
                      <div className="flex items-center gap-3">
                        <item.icon size={20} />
                        <span className="text-sm md:text-base">{item.label}</span>
                      </div>
                      {expandedSections[item.id] ? (
                        <ChevronDown size={16} />
                      ) : (
                        <ChevronRight size={16} />
                      )}
                    </button>
                    
                    {expandedSections[item.id] && (
                      <div className="ml-6 mt-1 space-y-1">
                        {item.subsections.map((sub) => (
                          <button
                            key={sub.id}
                            onClick={() => handleSectionClick(sub.section)}
                            className={`w-full text-left p-2 pl-4 hover:bg-gray-800 rounded transition-colors text-sm ${
                              currentSection === sub.section ? 'bg-gray-800 text-blue-400' : 'text-gray-300'
                            }`}
                            data-testid={`submenu-${sub.id}`}
                          >
                            {sub.label}
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                ) : (
                  <button
                    onClick={() => handleSectionClick(item.section)}
                    className={`w-full flex items-center gap-3 p-3 hover:bg-gray-800 rounded-lg transition-colors ${
                      currentSection === item.section ? 'bg-gray-800 text-blue-400' : ''
                    }`}
                    data-testid={`menu-${item.id}`}
                  >
                    <item.icon size={20} />
                    <span className="text-sm md:text-base">{item.label}</span>
                  </button>
                )}
              </div>
            ))}
          </nav>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
